import Axios from 'axios';
import * as constants from '../StoreConstants/XTimeScheduleServiceConstants';
export const XTimeScheduleServicePage = {
  state: {
    requiredServiceComments: false,
    additionalServiceComments: '',
    transportTypes: [],
    transportValetOptions: {
      pickupAddress: '',
      dropOffAddress: '',
      comments: '',
      loaner: false,
    },
    transportError: false,
    dropOff: 'DROPOFF',
    showNextBtn: true,
    scheduleServiceStepNames:
      window.deliveryConfiguration === 1
        ? [
            'Choose Your Appointment and Preferred Time',
            'What type of service do you need?',
            'Select your offers',
            'Trade-in Vehicle Appraisal',
            'Service Appointment Summary',
          ]
        : [
            'What type of service do you need?',
            'Select your offers',
            'Choose Your Appointment and Preferred Time',
            'Trade-in Vehicle Appraisal',
            'Service Appointment Summary',
          ],
    xTimeSubmitted: false,
    selectedStyle: '',
    availabiityServiceCallCount: 0,
    selectedMake: '',
    serviceDescribe: '',
    transportType: 'DROPOFF',
    selectedAdvisor: {
      advisorId: '',
      transportName: '',
    },
    selectedVehicle: {},
    displaySelectedAdminServices: [],
    serviceType: '',
    // scheduleType: '',
    servicePreference: '',
    serviceSettings: '',
    serviceAppraisal: window.enableServiceAppraisal,
    serviceComments: '',
    logLeadPayload: {},
    emailPayload: {},
    loggedInUserInfo: '',
    selectedCoupons: '',
    coupons: [],
    bookingFailedMessage: '',
    applicationId: '448EB9AE-FC73-45F3-BE16-1D75C2BD666C',
    serviceError: false,
    allSelectedFilteredServices: [],
    selectedServices: [],
    serviceTypes: [],
    slotDateTime: '',
    monthNames: [],
    noSlotsAvailable: '',
    selectedTime: '',
    selectedDate: '',
    showAvailableSlots: false,
    startDate: '',
    serviceNames: [],
    individualServiceList: [],
    userDetails: '',
    bookingSlotTime: '',
    availableAppointments: [],
    campaignId: parseInt(window.campaignid),
    accountId: parseInt(window.accountId),
    individualOpcodes: [],
    addServiceOpcode: false,
    servicePackageOpcode: '',
    showLoading: false,
    currentComponent: 'x-time-schedule-service-step-1',
    vehicleDetails: '',
    currentStep: 1,
    services: '',
    searchByVin: window.isauthenticated === 'True',
    webServiceLogRequest: {
      id: 0,
      method: '',
      request: '',
      response: '',
      message: '',
      exception: '',
      applicationSource: '',
      appointmentId: 0,
      typeId: 0,
      responseId: '',
      campaignID: parseInt(window.campaignId),
      accountId: parseInt(window.accountId),
      dRaiverAccountId: '',
      sessionId: window.tid,
    },
  },
  mutations: {
    [constants.ADDITIONAL_SERVICE_COMMENTS](state, payload) {
      state.additionalServiceComments = payload;
    },
    [constants.GET_TRANSPORT_TYPES](state, payload) {
      state.transportTypes = payload;
    },
    [constants.TRANSPORT_VALET_OPTIONS](state, payload) {
      state.transportValetOptions = payload;
    },
    [constants.TRANSPORT_TYPE](state, payload) {
      state.transportType = payload;
    },
    [constants.SHOW_NEXT_BUTTON](state, payload) {
      state.showNextBtn = payload;
    },
    [constants.X_TIME_SUBMITTED](state, payload) {
      state.xTimeSubmitted = payload;
    },
    [constants.SELECTED_STYLE](state, payload) {
      state.selectedStyle = payload;
    },
    [constants.AVAILABILITY_SERVICE_CALL_COUNT](state, payload) {
      if (payload && payload === 'zero') {
        state.availabiityServiceCallCount = 0;
      } else {
        state.availabiityServiceCallCount++;
      }
    },
    [constants.SELECTED_MAKE](state, payload) {
      state.selectedMake = payload;
    },
    [constants.SERVICE_COMMENTS_DESCRIBE](state, payload) {
      state.serviceDescribe = payload;
    },
    [constants.SELECTED_VEHICLE](state, payload) {
      state.selectedVehicle = { ...state.selectedVehicle, ...payload };
    },
    [constants.ADVISOR](state, payload) {
      state.selectedAdvisor[payload.key] = payload.value;
    },
    [constants.SELECTED_ADMIN_SERVICE_NAMES](state, payload) {
      state.displaySelectedAdminServices = payload;
    },
    [constants.SCHEDULE_SERVICE_TYPE](state, payload) {
      state.serviceType = payload;
    },
    // [constants.SCHEDULE_TYPE](state, payload) {
    //   state.scheduleType = payload;
    // },
    [constants.SET_SERVICE_DATA](state, payload) {
      state.serviceSettings = payload;
    },
    [constants.SERVICE_PREFERENCE](state, payload) {
      state.servicePreference = payload;
    },
    [constants.SERVICE_APPRAISAL](state, payload) {
      state.serviceAppraisal = payload;
    },
    [constants.SERVICE_COMMENTS](state, payload) {
      state.serviceComments = payload;
    },
    [constants.EMAIL_PAYLOAD](state, payload) {
      state.emailPayload = payload;
    },
    [constants.LOG_LEAD_PAYLOAD](state, payload) {
      state.logLeadPayload = payload;
    },
    [constants.LOGGED_IN_USER_INFO](state, payload) {
      state.loggedInUserInfo = payload;
    },
    [constants.SELECTED_COUPON_IDS_NAMES](state, payload) {
      state.selectedCoupons = payload;
    },
    [constants.SERVICE_COUPONS](state, payload) {
      state.coupons = payload;
    },
    [constants.SELECTED_TIME_SLOT](state, payload) {
      state.selectedTime = payload;
    },
    [constants.SHOW_AVAILABLE_SLOTS](state) {
      state.showAvailableSlots = true;
    },
    [constants.SLOT_DATE_TIME](state, payload) {
      state.slotDateTime = payload;
    },
    [constants.USER_DETAILS](state, payload) {
      state.userDetails = payload;
    },
    [constants.BOOKING_SLOT_TIME](state, payload) {
      state.bookingSlotTime = payload;
    },
    [constants.SEARCH_BY_VIN](state, payload) {
      state.searchByVin = payload;
    },
    [constants.INCREMENT_STEP](state) {
      state.currentStep++;
      state.currentComponent = 'x-time-schedule-service-step-' + state.currentStep;
    },
    [constants.DECREMENT_STEP](state) {
      if (state.currentStep > 1) {
        state.currentStep--;
      }
      state.currentComponent = 'x-time-schedule-service-step-' + state.currentStep;
    },
    [constants.SERVICES_DATA](state, payload) {
      //x time service list
      let serviceList = payload.data.services;
      serviceList.forEach((item) => {
        if (item.comment === '1') {
          item.isRequired = true;
          item.comment = '';
        } else {
          item.isRequired = false;
        }
      });
      state.services = payload;
    },
    [constants.VEHICLE_INFO](state, payload) {
      state.vehicleDetails = { ...state.vehicleDetails, ...payload };
    },
    [constants.SHOW_LOADING](state, payload) {
      state.showLoading = payload;
    },
    [constants.IS_SERVICE_PACKAGE_SELECTED](state, payload) {
      state.addServiceOpcode = payload;
    },
    // [constants.INDIVIDUAL_OP_CODES](state, payload) {
    //   state.individualOpcodes = payload;
    // },
    [constants.INDIVIDUAL_SERVICE_LIST](state, payload) {

      state.individualServiceList = payload;
    },
    [constants.SERVICE_PACKAGE_OP_CODE](state, payload) {
      state.servicePackageOpcode = payload;
    },
    [constants.START_DATE](state, payload) {
      state.startDate = payload;
    },
    [constants.NO_SLOTS_AVAILABLE](state, payload) {
      state.noSlotsAvailable = payload;
    },
    [constants.MONTH_NAMES](state, payload) {
      let dates = payload;
      const unique = [
        ...new Set(
          dates.map((item) =>
            new Date(item.calendarDate).toLocaleString('default', {
              month: 'short',
            })
          )
        ),
      ];
      state.monthNames = unique;
    },
    [constants.SET_SELECTED_DATE](state, payload) {
      state.selectedDate = payload;
    },
    [constants.SERVICE_ERROR](state, payload) {
      state.serviceError = payload;
    },
    [constants.ALL_FILTERED_SELECTED_SERVICES](state) {
      state.allSelectedFilteredServices = [];
    },
    [constants.SET_CURRENT_STEP](state, payload) {
      state.currentStep = payload;
      state.currentComponent = 'x-time-schedule-service-step-' + payload;
    },
    [constants.SET_SERVICE_TYPES](state, payload) {
      //admin all service types

      state.serviceTypes = payload;
    },
    [constants.SET_SELECTED_SERVICE_TYPES](state, payload) {
      //admin service types seleted
      state.selectedServices = payload;
    },
    [constants.FILTER_SERVICE_OPCODES](state) {

      const selectedAdminServices = state.selectedServices;
      const xTimeIndividualServiceList = state.services.data.services;
      let filteredServices = xTimeIndividualServiceList.filter((elem) =>
        selectedAdminServices.find(({ opcode, comment }) => {
          let addComment = elem.comment ? elem.comment.trim() : '';
          let serviceComment = comment ? comment.trim() : '';
          elem.comment = [addComment, serviceComment].filter(Boolean).join(', ');
          return elem.opcode === opcode;
        })
      );

      const genericServices = selectedAdminServices.filter((array) =>
        filteredServices.every((filter) => filter.opcode !== array.opcode)
      );
      //generic service is for tell us more starts
      let genericServiceArr = [];
      genericServices.map((item) => {
        genericServiceArr.push(item.serviceName);
      });
      let tellUsMore = genericServices;
      if (tellUsMore.length > 0) {
        tellUsMore[0].opcode = state.services.data.tellusMore.opcode;
        tellUsMore[0].serviceName = 'Tell Us More';
        tellUsMore[0].price = '';
        tellUsMore[0].serviceCategoryId = '';
        tellUsMore[0].serviceCategoryName = '';
        let getTellUsMore = filteredServices.filter((item) => item.serviceName === 'Tell Us More');
        getTellUsMore.forEach((data) => {
          genericServiceArr.push(data.comment);
        });
        tellUsMore[0].comment = genericServiceArr.length > 0 ? genericServiceArr.toString() : '';
      }

      //generic service ends

      if (filteredServices.length === 0 && genericServices.length === 0) {
        //this if condition can be removed
        selectedAdminServices.map((item) => {
          item['comment'] = '';
          item['price'] = '';
          item['serviceCategoryId'] = '';
          item['serviceCategoryName'] = '';
          item['serviceName'] = 'Tell Us More';
        });
      }

      let xTimeServices = state.individualServiceList;
      //this line is to remove tellus more from services to make unique
      if (genericServices.length !== 0) {
        filteredServices = filteredServices.filter((item) => item.serviceName !== 'Tell Us More');
      }
      //removing duplicate ends
      state.allSelectedFilteredServices = [];
      let genericList = [];
      if (tellUsMore.length > 0) {
        genericList.push(tellUsMore[0]);
      }
      state.allSelectedFilteredServices = [
        ...filteredServices,
        // ...genericServices,
        ...genericList,
        ...xTimeServices,
      ];


      state.allSelectedFilteredServices.map((item) => {
        if (item.serviceName.toLowerCase() === 'tell us more') {
          item.comment =
            tellUsMore && tellUsMore.length > 0
              ? tellUsMore[0].comment.replace("Describe What's Going On", '')
              : '';
          item.comment = item.comment + ',' + state.serviceDescribe;
        }
      });


    },
  },
  getters: {
    [constants.REQUIRED_ADDITIONAL_SERVICE_COMMENTS](state) {
      const adminServices = state.serviceTypes;
      let filteredArray = [];
      const selectedServiceNames = state.displaySelectedAdminServices;
      if (adminServices) {
        filteredArray = adminServices.filter(({ name }) => selectedServiceNames.includes(name));
      }
      let requireComments = filteredArray.filter((item) => item.requireComments === true);
      return requireComments.length > 0;
    },
    [constants.SELECTED_SERVICE_COUPONS_OBJECT](state) {
      let matched = [];
      state.coupons.filter((el) => {
        return !state.selectedCoupons.id.find((element) => {
          if (element === el.offerId) {
            matched.push(el);
          }
        });
      });
      return matched;
    },
    [constants.GET_STEP_NAMES](state) {
      let stepsForDeletion = [];
      if (!window.enableServiceAppraisal) {
        stepsForDeletion.push('Trade-in Vehicle Appraisal');
      }
      if (window.hideCouponSelectionStep) {
        stepsForDeletion.push('Select your offers');
      }
      let stepNames = state.scheduleServiceStepNames.filter(
        (item) => !stepsForDeletion.includes(item)
      );
      let newHeadingForServiceAppointmentSummary = state.serviceSettings
        ?.serviceSchedulerTextSettings?.mainTextServiceAppointment
        ? state.serviceSettings?.serviceSchedulerTextSettings?.mainTextServiceAppointment
        : 'Service Appointment Summary';

      if (newHeadingForServiceAppointmentSummary) {
        stepNames[stepNames.length - 1] = newHeadingForServiceAppointmentSummary;
      }
      return stepNames;
    },
    // [constants.TRANSPORT_TYPE](state) {
    //   let servicePreference = state.servicePreference;
    //   let transportType = servicePreference.includes('drop') ? 'DROPOFF' : 'WAITER';
    //   return transportType;
    // },
    [constants.DISPLAY_SERVICE_NAMES](state) {
      let displayNames = [];
      const selectedAdminServices = state.selectedServices;
      const xTimeIndividualServiceList = state.individualServiceList;
      if (xTimeIndividualServiceList && xTimeIndividualServiceList.length > 0) {
        xTimeIndividualServiceList.map((item) => {
          displayNames.push(item.serviceName);
        });
      }
      if (selectedAdminServices && selectedAdminServices.length > 0) {
        if (selectedAdminServices[0].comment) {
          let splitServices = selectedAdminServices[0].comment.split(',');
          displayNames = [...displayNames, ...splitServices];
        }
      }
      displayNames = [...new Set(displayNames)];
      return displayNames;
    },
    [constants.GET_CURRENT_COMPONENT_NAME](state) {
      let stepName = state.currentComponent;
      if (window.enableServiceAppraisal) {
        if (state.currentStep === 6) {
          stepName = 'x-time-schedule-service-step-8';
        } else if (state.currentStep === 7) {
          stepName = 'x-time-schedule-service-step-6';
        } else if (state.currentStep === 8) {
          stepName = 'x-time-schedule-service-step-7';
        } else {
          // No action needed for other cases.
        }
        if (window.hideCouponSelectionStep) {
          if (state.currentStep === 5) {
            stepName = 'x-time-schedule-service-step-8';
          } else if (state.currentStep === 6) {
            stepName = 'x-time-schedule-service-step-6';
          } else if (state.currentStep === 7) {
            stepName = 'x-time-schedule-service-step-7';
          } else {
            // No action needed for other cases.
          }
        }
      } else if (window.hideCouponSelectionStep) {
        if (state.currentStep === 6) {
          stepName = 'x-time-schedule-service-step-8';
        } else if (state.currentStep === 7) {
          stepName = 'x-time-schedule-service-step-6';
        } else if (state.currentStep === 8) {
          stepName = 'x-time-schedule-service-step-7';
        } else {
          // No action needed for other cases.
        }
        if (!window.enableServiceAppraisal) {
          if (state.currentStep === 5) {
            stepName = 'x-time-schedule-service-step-6';
          } else if (state.currentStep === 6) {
            stepName = 'x-time-schedule-service-step-7';
          } else {
            // No action needed for other cases.
          }
        }
      } else {
        // No action needed for other cases.
      }

      return stepName;
    },
    [constants.GET_SLOT_DATE_TIME](state) {
      let bookingTime = new Date(state.selectedDate.calendarDate).toLocaleDateString();
      //new code
      let selectedDate = new Date(bookingTime);
      let selectedTime = state.selectedTime;
      let hoursMin = selectedTime.split(':');
      selectedDate.setHours(selectedDate.getHours() + hoursMin[0]);
      selectedDate.setMinutes(selectedDate.getMinutes() + hoursMin[1]);
      return selectedDate;
    },
    [constants.GET_SELECTED_SERVICE_PACKAGE_NAME](state) {
      let serviceOpcode = state.servicePackageOpcode;
      let selectedPackage = '';
      if (state.services.data.servicePackages && state.services.data.servicePackages.length > 0) {
        selectedPackage = state.services.data.servicePackages.filter(
          (item) => item.opcode === serviceOpcode
        );
        return selectedPackage;
      }
    },
    [constants.GET_VEHICLE_MODEL](state) {
      let model =
        state.vehicleDetails && state.vehicleDetails.model !== '-1'
          ? state.vehicleDetails.model
          : '';

      return model;
    },
    [constants.SET_AVAILABILITIES_URL](state) {
      let newDate = new Date(state.startDate);

      let model =
        state.vehicleDetails && state.vehicleDetails.model !== '-1'
          ? state.vehicleDetails.model
          : '';
      let newModel = model;

      let estDateTime = newDate.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let estDate = estDateTime.split(',');
      let startDate = estDate[0];
      let requestObj = {
        ApplicationId: state.applicationId,
        CampaignId: state.campaignId,
        AccountId: state.accountId,
        vin: state.vehicleDetails?.vin || '',
        year:
          state.vehicleDetails && state.vehicleDetails.year !== '-1'
            ? state.vehicleDetails.year
            : '',
        make:
          state.vehicleDetails && state.vehicleDetails.make !== '-1'
            ? state.vehicleDetails.make
            : '',
        model: newModel,
        odometerMiles: state.vehicleDetails?.odometer || '',
        startDate: startDate,

        servicePackageOpcode: state.addServiceOpcode ? state.servicePackageOpcode : '',
        tellusMore: '',
        transportType: state.transportType,
        advisorId: state.selectedAdvisor.advisorId,
        SessionId: window.tid,
      };
      let valetString = '';

      let params = new URLSearchParams();
      for (const [key, value] of Object.entries(requestObj)) {
        if (value) {
          params.append(key, value);
        }
      }
      if (state.transportType === 'VALET') {
        valetString = `&valet.pickupAddress=${state.transportValetOptions.pickupAddress}&valet.dropOffAddress=${state.transportValetOptions.dropOffAddress}&valet.loaner=${state.transportValetOptions.loaner}`;
        params = params + valetString;
      }
      let allServices = state.allSelectedFilteredServices;

      let url = new URL(`${window.xtimeApiUrl}/Xtime/Availabilities`);
      url.search = params;
      let uniqueOpCodes = [];
      if (allServices.length === 0 && state.servicePackageOpcode) {
        url = url.href;
      }
      if (allServices.length > 0) {
        allServices.forEach((x) => {
          if (x) {
            state.serviceNames.push(x.serviceName);
            uniqueOpCodes.push(x.opcode);
          }
        });
        uniqueOpCodes = [...new Set(uniqueOpCodes)];
        uniqueOpCodes.forEach((x) => {
          url += `&serviceOpcodes=${x}`;
        });
      }

      return url;
    },
  },
  actions: {
    [constants.GET_X_TIME_SERVICE_TYPES](context, payload) {
      let newModel = payload.model ? payload.model : '';

      let url = new URL(`${window.xtimeApiUrl}/Xtime/Services`);

      context.commit(constants.SHOW_LOADING, true);
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(payload)) {
        if (value) {
          params.append(key, value);
        }
      }
      url.search = params;
      context.commit(constants.SERVICE_ERROR, '');

      Axios.get(url)
        .then((response) => {
          context.commit(constants.SHOW_LOADING, false);
          context.commit(constants.INCREMENT_STEP);
          context.commit(constants.SERVICES_DATA, response);
          payload.model = newModel;
          context.commit(constants.VEHICLE_INFO, payload);
          let webServiceRequest = {
            request: url,
            response: response,
            typeId: 33,
          };
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          if (!response.data.success) {
            context.commit(constants.SERVICE_ERROR, response.data.errorMsgForEndUser);
            context.commit(constants.DECREMENT_STEP);
          }
        })
        .catch(() => {
          context.commit(constants.SHOW_LOADING, false);

          context.commit(constants.SHOW_LOADING, false);

          console.log('error');
        });
    },
    [constants.WEB_SERVICE_LOG](context, payload) {
      let url = `${window.logsApiUrl}/WebServiceLog`;
      //browser info
      let userAgent = navigator.userAgent;
      let date = new Date();
      //EST DATE CONVERSION
      let estDateTime = context.state.startDate.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      let estDate = estDateTime.split(',');
      //CONVERSION ENDS
      //ENDS
      //  context.state.webServiceLogRequest.message=userAgent+',timezone offset'+date.getTimezoneOffset()+',time zone:'+Intl.DateTimeFormat().resolvedOptions().timeZone
      context.state.webServiceLogRequest.message = `${userAgent},timezone offset ${date.getTimezoneOffset()},time zone: ${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      },Date:${estDate[0]}`;

      let request = { ...context.state.webServiceLogRequest };
      request.request = JSON.stringify(payload.request);
      request.response = JSON.stringify(payload.response);
      let newModel = context.getters[constants.GET_VEHICLE_MODEL];
      request['status'] = payload?.response?.data?.success ? 'success' : 'failure';
      request['name'] = payload?.request?.firstName
        ? `${payload.request?.firstName} ${payload.request?.lastName}`
        : '';
      request['year'] = context.state.vehicleDetails.year || '';
      request['make'] = context.state.vehicleDetails.make || '';
      request['model'] = newModel || '';
      request['vin'] = context.state.vehicleDetails?.vin || '';
      request.typeId = payload.typeId;
      Axios.post(url, request)
        .then((response) => {})
        .catch((e) => {
          console.log(e);
        });
    },
    [constants.GET_AVAILABLE_SLOTS](context) {
      context.commit(constants.SHOW_LOADING, true);
      let url = context.getters[constants.SET_AVAILABILITIES_URL];
      context.commit(constants.SERVICE_ERROR, '');
      Axios.get(url)
        .then((response) => {
          context.state.availableAppointments = response.data;
          context.commit(constants.SERVICE_ERROR, '');

          //display month names on top calendar

          context.commit(constants.MONTH_NAMES, response.data.uiFormattedResponse);
          //display month name ends
          let formatedResponse = response.data.uiFormattedResponse;

          let noSlots = false;
          for (const element of formatedResponse) {
            if (element.isOpen) {
              context.state.selectedDate = element;
              context.commit(constants.NO_SLOTS_AVAILABLE, '');
              noSlots = false;
              context.commit(constants.AVAILABILITY_SERVICE_CALL_COUNT, 'zero');
              break;
            } else {
              noSlots = true;
            }
          }
          if (noSlots) {
            context.commit(constants.AVAILABILITY_SERVICE_CALL_COUNT);
          }
          let webServiceRequest = {
            request: url,
            response: response,
            typeId: 35,
          };
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          context.commit(constants.SHOW_LOADING, false);
          context.commit(constants.SHOW_AVAILABLE_SLOTS, true);
          //showing api validation errors in popup
          if (!response.data.success) {
            context.commit(constants.SERVICE_ERROR, response.data.errorMsgForEndUser);
            context.commit(constants.DECREMENT_STEP);
          }
          //ends
          if (noSlots && context.state.availabiityServiceCallCount < 4) {
            let lastDate = formatedResponse[formatedResponse.length - 1].calendarDate;
            let date = new Date(lastDate);
            let startDate = new Date(date.getTime() + 1000 * 60 * 60 * 24);
            context.commit(constants.START_DATE, startDate);
            context.dispatch(constants.GET_AVAILABLE_SLOTS);
            context.commit(constants.NO_SLOTS_AVAILABLE, 'No Slots Available');
          }
        })
        .catch((error) => {
          let webServiceRequest = {
            request: url,
            response: error,
            typeId: 35,
          };
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          context.commit(constants.SHOW_LOADING, false);
          context.commit(constants.DECREMENT_STEP);
          context.commit(constants.TRANSPORT_TYPE, context.state.dropOff);

          let message = `Unfortunately there was an issue scheduling this service with X-time, please select another service and try again or contact the store directly on ${window.serviceNumber} to schedule your service`;
          if (context.state.availableAppointments.errorMsgForEndUser) {
            message = context.state.availableAppointments.errorMsgForEndUser;
          }
          context.commit(constants.SERVICE_ERROR, message);
          console.log('error');
        });
    },
    async [constants.AVAILABILITIES_CALL_TO_CHECK_WAITER](context) {
      context.commit(constants.SHOW_LOADING, true);
      let url = context.getters[constants.SET_AVAILABILITIES_URL];
      let webServiceRequest = {
        request: '',
        response: '',
        typeId: 75,
      };
      url = url.replace('Availabilities', 'GetTransportations');
      let splitUrl = url.split('&');
      let paramsArr = splitUrl.filter(function (currentWord) {
        let exist =
          currentWord.includes('transportType') ||
          currentWord.includes('startDate') ||
          currentWord.includes('advisorId');
        return !exist;
      });
      const urlParams = paramsArr.join('&');
      await Axios.get(urlParams)
        .then((response) => {
          context.commit(constants.GET_TRANSPORT_TYPES, response.data.transportTypes);
          webServiceRequest.request = urlParams;
          webServiceRequest.response = response;
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          context.commit(constants.SHOW_LOADING, false);
        })
        .catch((error) => {
          console.log(error);
          webServiceRequest.request = urlParams;
          webServiceRequest.response = error;
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          context.commit(constants.SHOW_LOADING, false);
        });
    },
    [constants.GET_SERVICE_TYPES](context) {
      let url = `${window.ApiBaseUrl}/ServiceScheduler/ScheduleServiceTypes?accountId=${window.accountId}`;
      Axios.get(url).then((response) => {
        context.commit(constants.SET_SERVICE_TYPES, response.data);
      });
    },
    [constants.CALL_EMAIL_API](context) {
      let payload = context.state.emailPayload;
      //adding service package to comments
      let selectedPkg = context.getters[constants.GET_SELECTED_SERVICE_PACKAGE_NAME];
      if (selectedPkg && selectedPkg.length > 0) {
        payload[
          'service'
        ] = `${payload['service']},${selectedPkg[0].serviceName},${selectedPkg[0].opcode}`;
      }
      //ends
      Axios.post(`${window.ApiBaseUrl}/Email/schedule_your_service`, payload).then(() => {
        this.success = true;
      });
    },
    [constants.SCHEDULES_SERVICE_SETTINGS](context) {
      const datesec = new Date().getTime();
      Axios.get(
        `${window.ApiBaseUrl}/ServiceScheduler/ServiceSchedulerSettings?campaignID=${window.campaignId}&accountId=${window.accountId}&nocache=true&v=${datesec}`
      )
        .then((response) => {
          if (response.status === 200) {
            context.commit(constants.SET_SERVICE_DATA, response.data);
          }
        })
        .catch(() => {
          context.commit(constants.SHOW_LOADING, false);
        });
    },
    [constants.BOOK_APPOINTMENT_SLOT](context) {
      let url = `${window.xtimeApiUrl}/Xtime/BookAppointment`;

      let currentYear = new Date().getFullYear().toString();
      let bookingTime = new Date(context.state.selectedDate.calendarDate).toLocaleDateString();
      let allServices = context.state.allSelectedFilteredServices;
      let selectedDate = new Date(bookingTime);
      let selectedTime = context.state.selectedTime;
      let hoursMin = selectedTime.split(':');
      selectedDate.setHours(selectedDate.getHours() + hoursMin[0]);
      selectedDate.setMinutes(selectedDate.getMinutes() + hoursMin[1]);
      let offsetWithTime = context.state.selectedTime;
      let splitTime = offsetWithTime.split(':');
      let offsetTime = splitTime[2].split('-')[1];
      let finalTime = `${splitTime[0]}:${splitTime[1]}-${offsetTime}:${splitTime[3]}`;
      //ends
      let newModel = context.getters[constants.GET_VEHICLE_MODEL]; //split vehicle model for honda Accord..etc
      let serviceCoupons = context.state.selectedCoupons ? context.state.selectedCoupons.names : '';
      let comments = context.state.userDetails ? context.state.userDetails.comment : '';
      let couponsNameWithPrice = '';
      if (serviceCoupons && serviceCoupons.length > 0) {
        let couponsObject = context.getters[constants.SELECTED_SERVICE_COUPONS_OBJECT];
        couponsObject.map((item) => {
          couponsNameWithPrice += `, ${item.heading}:${item.amountText}`;
        });
        if (couponsNameWithPrice) {
          couponsNameWithPrice = couponsNameWithPrice.replace(/(^,)|(,$)/g, '');
          comments = `${comments},serviceCoupons:${couponsNameWithPrice}`;
        }
        let appraisalReq = context.state.serviceAppraisal ? 'Yes' : 'No';
        comments = `${comments},Appraisal:${appraisalReq}`;
      }
      let servicePreferenceOption = context.state.servicePreference;
      comments = `${comments},${servicePreferenceOption}`;
      let request = {
        ApplicationId: context.state.applicationId,
        CampaignId: context.state.campaignId,
        AccountId: context.state.accountId,
        vin: context.state.vehicleDetails?.vin || '',
        year:
          context.state.vehicleDetails && context.state.vehicleDetails.year !== '-1'
            ? context.state.vehicleDetails.year
            : '',
        make:
          context.state.vehicleDetails && context.state.vehicleDetails.make !== '-1'
            ? context.state.vehicleDetails.make
            : '',
        model: newModel,
        odometer: context.state.vehicleDetails?.odometer.toString() || '',
        appointmentId: '',
        appointmentDateTimeLocal: finalTime,
        firstName: context.state.userDetails ? context.state.userDetails.firstName : '',
        lastName: context.state.userDetails ? context.state.userDetails.lastName : '',
        emailAddress: context.state.userDetails ? context.state.userDetails.emailAddress : '',
        phoneNumber: context.state.userDetails ? context.state.userDetails.phoneNumber : '',
        comment: comments,
        transportType: context.state.transportType,
        advisorId: context.state.selectedAdvisor.advisorId,
        sessionId: window.tid,
      };
      let requireServiceComments = context.getters[constants.REQUIRED_ADDITIONAL_SERVICE_COMMENTS];

      if (allServices && allServices.length > 0) {
        // Remove isRequired property from all services if present
        allServices.forEach((service) => {
          if ('isRequired' in service) {
            delete service.isRequired;
          }
        });
        allServices[0].comment = requireServiceComments
          ? `${allServices[0].comment} ${context.state.additionalServiceComments}`
          : `${allServices[0].comment}`;

        request['services'] = allServices;
      }
      let selectedPkg = context.getters[constants.GET_SELECTED_SERVICE_PACKAGE_NAME];

      if (context.state.addServiceOpcode && selectedPkg && selectedPkg.length > 0) {
        request['servicePackage'] = selectedPkg[0];
      }
      context.commit(constants.SHOW_LOADING, true);
      context.state.bookingFailedMessage = '';
      //SERVICE OPCODE
      let opcode = context.state.serviceAppraisal;
      if (opcode && context.state.serviceTypes[0].vehicleAppraisalOPTCode) {
        let appraisalOpcode = context.state.serviceTypes[0].vehicleAppraisalOPTCode
          ? context.state.serviceTypes[0].vehicleAppraisalOPTCode
          : 0;
        let appraisalObject = {
          serviceName: 'Schedule Service Appraisal OpCode',
          opcode: appraisalOpcode,
          price: '',
          serviceCategoryId: '',
          serviceCategoryName: '',
          comment: 'Appraisal OpCode',
        };
        request.services.push(appraisalObject);
      }
      if (context.state.transportType === 'VALET') {
        request['valet'] = context.state.transportValetOptions;
      }
      //ENDS
      context.commit(constants.SERVICE_ERROR, '');


      Axios.post(url, request)
        .then((response) => {
          context.commit(constants.SHOW_LOADING, false);
          if (response.data.success) {
            context.dispatch(constants.CALL_EMAIL_API);
            context.commit(constants.INCREMENT_STEP);
            context.commit(constants.X_TIME_SUBMITTED, true);
          } else {
            let loggedInVehicleYear =
              context.state.loggedInUserInfo?.vehicle?.ConsumerInterestedVehicle?.Year ||
              currentYear;
            let vehicle = {
              vin: '',
              year: loggedInVehicleYear.toString(),
              make: 'OTHER',
              model: 'OTHER',
            };
            if (request.vin && !response.data.success) {
              context.commit(constants.VEHICLE_INFO, vehicle);
              context.dispatch(constants.BOOK_APPOINTMENT_SLOT);
            } else {
              context.commit(constants.SERVICE_ERROR, response.data.errorMsgForEndUser);
            }
          }
          let webServiceRequest = {
            request: request,
            response: response,
            typeId: 37,
          };
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
        })
        .catch((e) => {
          context.commit(constants.SHOW_LOADING, false);
          context.state.bookingFailedMessage = 'Something went wrong please try again.';
          let webServiceRequest = {
            request: request,
            response: e,
            typeId: 37,
          };
          context.dispatch(constants.WEB_SERVICE_LOG, webServiceRequest);
          console.log(e);
        });
    },
  },
};
